import { Jira } from './src/jiraFromUI';
export const JiraFromUI = new Jira();
export var SubscriptionEvents;
(function (SubscriptionEvents) {
    SubscriptionEvents["frameIsReady"] = "frameIsReady";
    SubscriptionEvents["sendPropsToFrame"] = "sendPropsToFrame";
    SubscriptionEvents["openReschedule"] = "openReschedule";
    SubscriptionEvents["workItemUpdated"] = "workItemUpdated";
    SubscriptionEvents["newBooking"] = "newBooking";
})(SubscriptionEvents || (SubscriptionEvents = {}));
